<template>
  <el-dialog top="3vh" :visible.sync="visible" width="75vw"
             :close-on-click-modal="false"
             :close-on-press-escape="false" @closed="closedHandler" center>
    <h3 slot="title">Assign Role to <i class="text-primary">{{ user.name }}</i></h3>
    <el-row :gutter="24" class="d-flex justify-center">
      <el-col :span="18" :offset="3">
        <el-transfer
            filterable
            :titles="['Unassigned', 'User Roles']"
            v-model="assigned"
            :data="unassigned">
        </el-transfer>
      </el-col>
    </el-row>

    <div slot="footer" class="dialog-footer">
      <el-button type="default" @click="visible = false">Cancel</el-button>
      <el-button :loading="loading" type="primary" @click="saveChanges">Save changes</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'user-assign-role-modal',
  props: ['user'],
  data () {
    return {
      visible: true,
      users: [],
      unassigned: [],
      assigned: [],
      loading: false
    }
  },
  methods: {
    closedHandler () {
      this.$emit('close')
    },
    async getRoles () {
      try {
        const res = await this.$roleService.getRoles()
        this.roles = res
        this.unassigned = res.map(r => ({
          label: r.name,
          key: r.id,
          initials: r.name,
          guard_name: r.guard_name || 'api'
        }))
      } catch (error) {
        console.error('Error loading roles:', error)
        this.$message.error('Failed to load roles. Please try again.')
      }
    },
    async getUserRoles () {
      try {
        const res = await this.$roleService.getUserRoles(this.user.id)
        this.assigned = (res || []).map(r => r.id)
      } catch (error) {
        console.error('Error loading user roles:', error)
        this.assigned = []
        this.$message.error('Failed to load user roles. Please try again.')
      }
    },
    async saveChanges () {
      try {
        await this.withLoading(async () => {
          const response = await this.$roleService.assignUserRoles(this.user.id, {
            roles: this.assigned.filter(i => !!i)
          })

          // Emit event to parent to refresh user data
          this.$emit('roles-updated', { userId: this.user.id, roles: this.assigned })

          this.$notify.success(
            response.message || this.$t('user.message.assign_role').toString()
          )
          this.closedHandler()
          this.visible = false
        }, 'loading')
      } catch (error) {
        console.error('Error assigning roles:', error)
        const errorMessage = error.response?.data?.message || error.message || 'Failed to assign roles. Please try again.'
        this.$message.error(errorMessage)
      }
    },
    withLoading (fn, loadingKey) {
      this.loading = true
      return fn().finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.getUserRoles()
    this.getRoles()
  }
}
</script>
<style scoped>
</style>
